<script setup lang="ts">
const props = defineProps<{
  message: string;
}>();
</script>

<template>
  <div class="banner">
    <span v-html="message"></span>
  </div>
  <hr class="divider" />
</template>

<style lang="scss">
.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  background-color: $color-primary-darken;
  color: $color-neutral-white;

  a {
    color: $color-neutral-white;
  }

  a:hover {
    color: $color-neutral-hover;
  }
}
.divider {
  margin: 0;
  border: none;
  height: 1px;
}
</style>
